import UniversalInput from "components/uiComponents/UniversalInput";
import { ReactComponent as RemoveIcon } from "../../../../static/icons/cross-circle-gray.svg";
import { ReactComponent as UniqueIcon } from "../../../../static/icons/unique-icon.svg";
import Select from "../Select/Select";
import "./ColorSettingsItem.scss";
import { updateColorItemAC } from "store/actions/colorSidebar";
import { useDispatch } from "react-redux";
import { textTypeEnum } from "utils/types";
import DatePicker from "components/uiComponents/Datepicker";

const ColorSettingsItem = ({
  options,
  id,
  currentOption,
  currentColor,
  inputsDataArray,
  dropdownVerticalPosition,
  deleteItemCallback,
}) => {
  const dispatch = useDispatch();

  const setSelectedOption = (option) => {
    const updateData = {
      id,
      selectedOption: option,
    };
    updateItemHandler(updateData);
  };

  const handleUniversalInputChange  = (index) => {
     return (value) => {
      const newInputsDataArray = [...inputsDataArray]
      newInputsDataArray[index] = value
  
      const updateData = {
        id,
        inputsDataArray: newInputsDataArray,
      };
      updateItemHandler(updateData);
     }
  }

  const updateColorValue = (color) => {
    const updateData = {
      id,
      color,
    };
    updateItemHandler(updateData);
  };

  const updateItemHandler = (updateData) => {
    dispatch(updateColorItemAC(updateData));
  };

  const renderColorInput = () => {
    
    const isUniqueValue = currentOption?.key === textTypeEnum.uniqueValue

    const colorInputHandleChange = (event) => {
      updateColorValue(event.currentTarget.value)
    }
    
    if (isUniqueValue) {
      return (
        <div>
          <UniqueIcon/>
        </div>
      )
    }else {
      return  (
        <input 
          type="color"
          value={currentColor}
          onChange={colorInputHandleChange}
        />
      )
    }
  }
  const deleteItemHandler = () => {
    deleteItemCallback(id)
  }

  const firstDateValue = new Date(inputsDataArray?.[0])
  const secondDateValue = new Date(inputsDataArray?.[1])

  return (
    <div className="color-setting-item-wrapper">
      <div className="color-setting-item_top-content">
        <Select
          selectedValue={currentOption}
          setSelectedValue={setSelectedOption}
          dropdownVerticalPosition={dropdownVerticalPosition}
          isBold={false}
          textSize="md"
          customContainerClass="selectDropDownContainer"
          options={options}
        />
        {renderColorInput()}
        <div
          className="color-setting-item-delete-icon"
          onClick={deleteItemHandler}
        >
          <RemoveIcon />
        </div>
      </div>
      {currentOption?.hasInput ? (
        <UniversalInput
          value={inputsDataArray[0]}
          onChangeValue={handleUniversalInputChange(0)}
        />
      )
        : null
      }
      {currentOption?.hasSecondInput ? (
        <UniversalInput
          value={inputsDataArray[1]}
          onChangeValue={handleUniversalInputChange(1)}
        />
        ): null
      }
      {currentOption?.hasDatepicker ? (
          <DatePicker
            value={firstDateValue}
            onChangeValue={handleUniversalInputChange(0)}
          />
        ): null
      }

      {currentOption?.hasSecondDatepicker ? (
          <DatePicker
            value={secondDateValue}
            onChangeValue={handleUniversalInputChange(1)}
          />
        ): null
      }
    </div>
  );
};

export default ColorSettingsItem;
